import { render, staticRenderFns } from "./ServiceBlock.vue?vue&type=template&id=569eaf50&"
import script from "./ServiceBlock.vue?vue&type=script&lang=js&"
export * from "./ServiceBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports